import { InMemoryCache, NormalizedCacheObject } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { DefaultOptions } from "apollo-client"
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import CryptoJS from "crypto-js";
import fetch from "isomorphic-fetch";
import React from "react";

const createClient = (token: string): ApolloClient<NormalizedCacheObject> => {
  const httpLink = createHttpLink({ uri: `https://api.monday.com/v2`, fetch });
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ""
      }
    };
  });

  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

  return new ApolloClient({
    ssrMode: true,
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
    connectToDevTools: true
  });
};

const encrypted =
  "U2FsdGVkX1+b18hGnDQekdWJFlOonklSyM+tcWHBdD4hLOfwZNxiIeQoLjP7NtJ5HWUOp1vjUoDugSpmuJkrxZIlB/BGj5IJt02tNN0aVF+qzkHl+1+Z7H3Rk9pQSaDuTGCHrN8bS4fkyPA5w0m8yPWXoaR9wXPv8gIOUGWJIcDfs+tYb95oZ4r1jiC2zDHAycU33aI8CNs8zft9WLPmtwUpRb2RiSpYWpM5k5emZ8+5cCFkLZofcqAKr1aUbeeY";

const data = CryptoJS.AES.decrypt(
  encrypted,
  "ipS&Lp#s48PQUNqRA2KE&69Y"
).toString(CryptoJS.enc.Utf8);

const mondayClient = createClient(data);

const MondayClientContext = React.createContext(mondayClient);

function MondayClientContextProvider({ children }: any) {
  return (
    <MondayClientContext.Provider value={mondayClient}>
      {children}
    </MondayClientContext.Provider>
  );
}

export { MondayClientContext, MondayClientContextProvider };
